var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 45,
    viewBox: "0 0 293 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4562 34.2363C19.7838 30.2921 30.2997 27.5152 40.4084 24.5709C53.774 20.678 67.6459 16.1752 81.8641 13.71C85.0524 13.1572 84.008 14.5193 82.6393 15.7971C79.2729 18.9399 75.3541 21.967 71.663 24.9559C69.2429 26.9157 72.1623 25.3951 73.7714 24.7533C86.7197 19.5883 101.184 15.8412 115.506 12.6564C115.999 12.5467 128.653 9.42099 128.653 10.9948C128.653 12.2922 126.971 13.9548 126.11 15.0271C124.087 17.5486 121.749 19.9541 119.692 22.4636C119.491 22.7089 116.116 27.5152 116.188 27.509C118.125 27.344 120.688 25.9066 122.39 25.4017C128.454 23.6019 134.939 22.4573 141.49 21.7139C146.391 21.1576 151.343 20.8848 156.311 20.7818C158.47 20.737 163.751 20.1711 165.644 21.2883C167.155 22.1803 166.711 24.1959 166.419 25.3409C166.376 25.5104 165.513 26.8663 166.171 26.6175C174.721 23.3827 183.642 20.7573 193.084 18.796C200.137 17.331 207.404 16.2151 214.789 15.7971C217.75 15.6295 222.038 15.1965 224.959 15.8782C228.725 16.7571 225.621 19.8145 227.254 21.3086C228.484 22.4342 235.073 21.0999 235.997 20.9844C251.622 19.0319 267.214 16.9309 282.817 14.9055",
    stroke: "#EA4335",
    strokeWidth: 20.3724,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveHighlight);
export default __webpack_public_path__ + "static/media/wave-highlight.5a6b865630cdd77b4222a78c37925350.svg";
export { ForwardRef as ReactComponent };